import { RequestStatus } from '@lib/plugin-redux-core';
import { GlobalForm, SpaceObjects } from '@module/form';
import { RootReducerState } from 'redux/root.reducer';

export const formsAndFoldersSearchOptionsSelector = (state: RootReducerState): SpaceObjects =>
  state.spaceObjects.formsAndFoldersSearchOptions;

export const spaceObjectsSelector = (state: RootReducerState): SpaceObjects =>
  state.spaceObjects.spaceObjects;

export const searchFormsAndFoldersStatusSelector = (state: RootReducerState): RequestStatus =>
  state.spaceObjects.searchFormsAndFoldersStatus;

export const moveFolderPickerSpaceObjectsSelector = (state: RootReducerState): SpaceObjects =>
  state.spaceObjects.moveFolderPickerSpaceObjects;

export const moveFolderPickerStatusSelector = (state: RootReducerState): RequestStatus =>
  state.spaceObjects.moveFolderPickerStatus;

// Form
export const updateFormSummaryStatusSelector = (state: RootReducerState): RequestStatus =>
  state.spaceObjects.updateFormSummaryStatus;

export const deleteFormStatusSelector = (state: RootReducerState): RequestStatus =>
  state.spaceObjects.deleteFormStatus;

export const createFormStatusSelector = (state: RootReducerState): RequestStatus =>
  state.spaceObjects.createFormStatus;

export const importingFormIdsSelector = (state: RootReducerState): string[] =>
  state.spaceObjects.importingFormIds;

export const importingFormIdSelector = (state: RootReducerState): string =>
  state.spaceObjects.importingFormId;

export const hasErrorFormSelector = (state: RootReducerState): boolean =>
  state.spaceObjects.hasErrorForm;

export const findFormByIdsStatusSelector = (state: RootReducerState): RequestStatus =>
  state.spaceObjects.findFormByIdsStatus;

// Folder

export const updateFolderSummaryStatusSelector = (state: RootReducerState): RequestStatus =>
  state.spaceObjects.updateFolderSummaryStatus;

export const deleteFolderStatusSelector = (state: RootReducerState): RequestStatus =>
  state.spaceObjects.deleteFolderStatus;

export const getFolderByIdStatusSelector = (state: RootReducerState): RequestStatus =>
  state.spaceObjects.getFolderByIdStatus;

export const createFolderStatusSelector = (state: RootReducerState): RequestStatus =>
  state.spaceObjects.createFolderStatus;

export const newFormIdSelector = (state: RootReducerState): string => state.spaceObjects.newFormId;

// Global Form
export const globalFormsSelector = (state: RootReducerState): GlobalForm[] =>
  state.spaceObjects.globalForms;

// Load More Pagination
export const folderNextTokenSelector = (state: RootReducerState): string | null =>
  state.spaceObjects.folderNextToken;

export const formNextTokenSelector = (state: RootReducerState): string | null =>
  state.spaceObjects.formNextToken;

export const isLoadingMoreFoldersSelector = (state: RootReducerState): boolean =>
  state.spaceObjects.loadingMoreFoldersStatus === RequestStatus.EXECUTE;

export const isLoadingMoreFormsSelector = (state: RootReducerState): boolean =>
  state.spaceObjects.loadingMoreFormsStatus === RequestStatus.EXECUTE;
